import graphql__1216775a2dd187bf2cab from "./__generated__/ContributionsDatavizMainContainerHeader_theme.graphql.js";
import graphql__cb80f93b3c947b7299bc from "./__generated__/ContributionsDatavizMainContainerHeader_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import ContributionsDatavizViewModeSwitch from "./ContributionsDatavizViewModeSwitch";
import { useResponsiveFlag } from "../../../Utils/ResponsiveQueries";

const ContributionsDatavizMainContainerHeader = props => {
  const { children, graphViewActive, listViewActive, contributionDatavizRootTitleId } =
    props;

  const participativeModule = useFragment(
    ContributionsDatavizMainContainerHeader_participativeModule,
    props.participativeModule
  );
  const theme = useFragment(ContributionsDatavizMainContainerHeader_theme, props.theme);

  const { isMobile } = useResponsiveFlag();

  const leftContainerClassName = classNames("col-md-6", {
    "d-flex": isMobile,
    "justify-content-center": isMobile,
    "margin-bottom-xs": isMobile
  });

  const viewModeSwitchContainerClassName = classNames("col-md-6", {
    "d-flex": isMobile,
    "justify-content-center": isMobile
  });

  return (
    <div className="participative-datavisualization-theme-view-header box padding-sm margin-bottom-xs">
      <div className="row align-items-center">
        <div className={leftContainerClassName}>{children}</div>

        <div className={viewModeSwitchContainerClassName}>
          <ContributionsDatavizViewModeSwitch
            theme={theme}
            participativeModule={participativeModule}
            graphViewActive={graphViewActive}
            listViewActive={listViewActive}
            contributionDatavizRootTitleId={contributionDatavizRootTitleId}
          />
        </div>
      </div>
    </div>
  );
};

const ContributionsDatavizMainContainerHeader_theme = graphql__1216775a2dd187bf2cab;

const ContributionsDatavizMainContainerHeader_participativeModule = graphql__cb80f93b3c947b7299bc;

export default ContributionsDatavizMainContainerHeader;
